import Picker from "pickerjs";

export class BdayChange {
    constructor(optionalOptions = {}) {
        this._picker = document.querySelector('.polls-variant-bday--body .js-inline-picker');
        if (!this._picker) {
            this.destructor();
            return true;
        }

        let pickerBday = new Picker(this._picker, {
            controls: false,
            inline: true,
            format: 'DD - MM - YYYY',
            monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        });

        let thatPicker = this._picker;
        let pickerTarget
        let pickerInput
        let pickerTargetElement
        let pickerInputElement
        let date

        let observer = new MutationObserver(function (event) {
            if (event.length > 1) {
                pickerTarget = thatPicker.dataset.target;
                pickerInput = thatPicker.dataset.input;

                date = pickerBday.getDate(true);

                if (pickerTarget) {
                    pickerTargetElement = document.querySelector(pickerTarget)
                    if (pickerTargetElement) {
                        pickerTargetElement.innerHTML = date;
                    }
                }

                if (pickerInput) {
                    pickerInputElement = document.querySelector(pickerInput)
                    if (pickerInputElement) {
                        pickerInputElement.val = date;
                    }
                }
            }
        })

        let onePicker
        let pickers = this._picker.querySelectorAll('.picker-list')
        for (let i = 0; i < pickers.length; ++i) {
            onePicker = pickers[i];
            observer.observe(onePicker, {
                attributes: true,
                childList: true,
                characterData: false
            })
        }
    }

    destructor() {
        this._picker = null;
    }
}

export default new BdayChange();